import {
    RequestKeys,
} from 'app/hooks/useRequest'

import ChangeHistory from 'app/shared-components/ChangeHistory'

import config from 'app/requests/Opportunity/Opportunity.requests'
import {
    WithId,
} from 'app/types/common.types'

const OpportunitiesChangeHistory = ({
    id,
}: Readonly<WithId<number>>) => {
    return (
        <ChangeHistory
            id={id}
            requestKey={RequestKeys.getOpportunityModifications}
            config={config.modifications}
            configName="OpportunityHistoryTable"
            name="OpportunityChangeHistory"
            labelPrefixForChangedColumn={['Opportunity']}
        />
    )
}

export default OpportunitiesChangeHistory
